import {
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";
import "moment/locale/ru";
import React, { Component } from "react";
import withServices from "../hocs/withServices";
import { MuiTelInput } from "mui-tel-input";

const styles = (theme) => ({
  root: {},
  pageContent: {
    [theme.breakpoints.up("sm")]: {
      margin: theme.spacing(5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("xs")]: {
      margin: theme.spacing(0),
      padding: theme.spacing(1),
    },
  },
});

class ProfileSettings extends Component {
  state = {
    errorMessage: "",
    name: "",
    translitiratedName: "",
    surname: "",
    translitiratedSurname: "",
    patronymic: "",
    phoneNumber: "",
    password: "",
  };

  componentDidMount() {
    const data = JSON.parse(localStorage.getItem("user"));

    this.setState({
      name: data.name,
      translitiratedName: data.nameInLatin ?? "",
      surname: data.surname,
      translitiratedSurname: data.surnameInLatin ?? "",
      patronymic: data.patronymic,
      phoneNumber: data.phoneNumber,
    });
  }

  handleSubmit = () => {
    const { state } = this;
    const data = {
      name: state.name || null,
      nameInLatin: state.translitiratedName || null,
      surname: state.surname || null,
      surnameInLatin: state.translitiratedSurname || null,
      patronymic: state.patronymic || null,
      phoneNumber: state.phoneNumber || "",
      password: state.password || null,
    };

    this.props.services.personalSettingsService
      .updateAccountInfo(data)
      .then((response) => {
        localStorage.setItem("user", JSON.stringify(response.data));
        alert("Ваши данные были успешно обновлены");
      })
      .catch(() => {
        this.setState({
          errorMessage: "При сохранении ваших данных произошла какая-то ошибка",
        });
      });
  };

  render() {
    const { classes } = this.props;
    const { state } = this;

    return (
      <>
        <Paper className={classes.pageContent}>
          <form className={classes.root}>
            <Typography variant="h5">Настройки профиля</Typography>
            <br></br>
            <Grid container justify="center" spacing={3}>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Имя"
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^А-Яа-яәіңғүұқөһӘІҢҒҮҰҚӨҺ ]/gi, "");

                    this.setState({
                      name: value,
                    });
                  }}
                  value={state.name}
                />
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Фамилия"
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^А-Яа-яәіңғүұқөһӘІҢҒҮҰҚӨҺ ]/gi, "");

                    this.setState({
                      surname: value,
                    });
                  }}
                  value={state.surname}
                />
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Отчество"
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^А-Яа-яәіңғүұқөһӘІҢҒҮҰҚӨҺ ]/gi, "");

                    this.setState({
                      patronymic: value,
                    });
                  }}
                  value={state.patronymic}
                />
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Имя (транслитом)"
                  value={state.translitiratedName}
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^A-Za-z ]/gi, "");

                    this.setState({
                      translitiratedName: value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Фамилия (транслитом)"
                  value={state.translitiratedSurname}
                  onChange={(e) => {
                    let value = e.target.value;

                    value = value.replace(/[^A-Za-z ]/gi, "");

                    this.setState({
                      translitiratedSurname: value,
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                {/* <PhoneInput
                  style={{
                    width: "100%",
                    padding: "18.5px 14px",
                    fontSize: "1rem",
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    borderColor: "rgba(0, 0, 0, 0.23)",
                    borderRadius: "4px",
                  }}
                  value={this.state.phoneNumber}
                  onChange={(phoneNumber) => this.setState({ phoneNumber })}
                ></PhoneInput> */}

                <MuiTelInput
                  style={{
                    width: "100%",
                    fontSize: "1rem",
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    borderColor: "rgba(0, 0, 0, 0.23)",
                    borderRadius: "4px",
                  }}
                  defaultCountry='KZ'
                  value={this.state.phoneNumber}
                  onChange={(phoneNumber) => this.setState({ phoneNumber })}
                />
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Новый пароль"
                  onChange={(event) =>
                    this.setState({
                      password: event.target.value,
                    })
                  }
                  value={state.password}
                />
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <Grid container justify="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleSubmit}
                  >
                    Сохранить
                  </Button>
                </Grid>
              </Grid>

              <Typography color="error">{state.errorMessage}</Typography>
            </Grid>
          </form>
        </Paper>
      </>
    );
  }
}

export default withStyles(styles)(withServices()(ProfileSettings));
